import { CARGO_ROWS, CARGO_COLS, slotLabel, findBag } from "./cargoSlots";
import { BigBagPicker } from "./BigBagPicker";

const cell = (active) => `rounded-md text-[11px] font-bold uppercase tracking-wider transition-[background-color,transform,box-shadow] duration-150 active:scale-95 ${
  active ? "slot-pop bg-orange-500 text-white shadow-[0_0_0_3px_rgba(249,115,22,0.25)]" : "bg-white text-zinc-500 ring-1 ring-zinc-200 hover:bg-orange-50 hover:text-orange-700"}`;

export const CargoSlotPicker = ({ value, onChange, bags = [], onAddBag, onRemoveBag }) => {
  const pick = (code) => onChange(value === code ? "" : code);
  return (
    <div data-testid="cargo-slot-picker" className="space-y-1.5">
      <div className="flex items-baseline justify-between">
        <span className="text-xs font-semibold text-zinc-700">Miejsce na pace</span>
        <span data-testid="cargo-slot-selected" className="text-xs font-mono text-orange-700">{value ? slotLabel(value, findBag(value, bags)) : "nie wybrano"}</span>
      </div>
      <div className="flex gap-1.5 items-stretch">
        <div className="flex-1 rounded-xl bg-zinc-900 p-1.5 space-y-1">
          <button type="button" data-testid="cargo-slot-cab" onClick={() => pick("cab")} className={`${cell(value === "cab")} w-full py-1.5 rounded-t-[14px]`}>Kabina</button>
          <div className="grid grid-cols-3 gap-1">
            {CARGO_ROWS.flatMap(([r, rl]) => CARGO_COLS.map(([c, cl]) => {
              const code = `${r}-${c}`;
              return <button type="button" key={code} data-testid={`cargo-slot-${code}`} title={`${rl} · ${cl}`} aria-label={`${rl} ${cl}`} onClick={() => pick(code)} className={`${cell(value === code)} h-10`}>{rl.slice(0, 2)}·{cl[0].toUpperCase()}</button>;
            }))}
          </div>
          <p className="text-center text-[9px] font-mono uppercase tracking-widest text-zinc-500">drzwi tylne</p>
        </div>
        <button type="button" data-testid="cargo-slot-side" onClick={() => pick("side")} className={`${cell(value === "side")} w-9 [writing-mode:vertical-rl] rotate-180`}>Drzwi boczne</button>
      </div>
      <BigBagPicker bags={bags} value={value} onPick={pick} onAddBag={onAddBag} onRemoveBag={onRemoveBag} />
    </div>
  );
};
